<div *ngIf="isShowPayment && this.processId && !isPaymentLink">
    <div *ngIf="isShowTestCallBack" class="action-buttons">
        <button [id]="elementIds.success" *ngIf="isShowTestCallBack" class="button_icon icon_adjust callback-icon"
            style="background-color: green !important;" (click)="onAction(1)"
            title="{{localService.languageContent.common.success}}">done</button>
        &nbsp;
        <button [id]="elementIds.failed" *ngIf="isShowTestCallBack" class="button_icon icon_adjust callback-icon"
            style="background-color: red !important;" (click)="onAction(2)"
            title="{{localService.languageContent.common.failed}}">clear</button>
    </div>
</div>
<div class="payment-overlay" *ngIf="isPaymentLink && isShowPayment">
    <div class="payment-modal">
        <div>
            <h2>
                <span>Payment Link</span>
                <button class="button_icon button_icon_color"
                    style="transform: rotate(45deg);color: red !important;float: right;" (click)="onClose()">
                    add_circle_outline
                </button>
            </h2>
        </div>
        <div>
            <div class="payment-row">
                <div class="payment-row-col-1">
                    <app-label [Text]="'Customer Name'" [IsMandatory]="true" [IsColonRequired]="false" />
                </div>
                <div class="payment-row-col-2">
                    <input autocomplete="off" type="text" [(ngModel)]="customerDetails.v1"
                        [ngClass]="customerDetails.v1 ? 'en' : ''" [id]="elementIds.customer_name" />
                </div>
            </div>
            <div class="payment-row">
                <div class="payment-row-col-1">
                    <app-label [Text]="'Customer Email'" [IsMandatory]="true" [IsColonRequired]="false" />
                </div>
                <div class="payment-row-col-2">
                    <input autocomplete="off" type="text" [(ngModel)]="customerDetails.v2"
                        [id]="elementIds.customer_email" [ngClass]="customerDetails.v2 ? 'en' : ''" />
                </div>
            </div>
            <div class="payment-row">
                <div class="payment-row-col-1">
                    <app-label [Text]="'Contact Number'" [IsMandatory]="true" [IsColonRequired]="false" />
                    <div>
                        <span>Without country code</span>
                    </div>
                </div>
                <div class="payment-row-col-2">
                    <input autocomplete="off" type="number" style="text-align: left;" [(ngModel)]="customerDetails.v3"
                        [ngClass]="customerDetails.v3 ? 'en' : ''" [id]="elementIds.customer_contact" />
                </div>
            </div>
        </div>
        <div class="payment-link-actions">
            <div style="width: 60%;text-align: left;">
                <button class=" button_link link_btn" style="font-weight: bold;" (click)="onSwitchPaymentWindow()">
                    <span>Switch to payment window</span>
                </button>
            </div>
            <div style="width: 40%;text-align: right;">
                <button type="button" class="btn btn-primary" (click)="onLoad()">
                    <span>Generate Link</span>
                </button>
            </div>
        </div>
        <div *ngIf="paymentLinkUrl" class="box" style="margin-top: 30px;">
            <div>
                <app-label [Text]="'Payment URL'" />
            </div>
            <div>
                <span>{{paymentLinkUrl}}</span>
                <button class="button_icon button_icon_color icon_adjust" style="margin-left: 10px;float: right;"
                    (click)="localService.copyContent(paymentLinkUrl)">
                    content_copy
                </button>
            </div>
        </div>
    </div>
</div>